#import "./AssetFields.graphql"

mutation CreateAsset(
  $attributes: AssetAttributesInput!
  $status: AssetStatusEnum
  $assignToEmployeeId: ID
  $assignToLocation: AssetLocationEnum
  $assignedOn: ISO8601Date
) {
  createAsset(
    input: {
      attributes: $attributes
      status: $status
      assignToEmployeeId: $assignToEmployeeId
      assignToLocation: $assignToLocation
      assignedOn: $assignedOn
    }
  ) {
    asset {
      ...AssetFields
    }
  }
}
